import { CarouselFullWidth, CarouselSectionTypes } from '@dfh-corp-sites/ui'
import React, { useMemo } from 'react'

import { CarouselSectionProps } from './types'
import { transformLink } from './utils'

function CarouselSectionText({ textCarouselDeck }: Pick<CarouselSectionProps, 'textCarouselDeck'>) {
  const slides = useMemo(() => {
    if (!textCarouselDeck?.textSlides?.length) {
      return []
    }

    return textCarouselDeck.textSlides
      .filter((slide) => slide !== null)
      .map((slide, index) => ({
        ...slide,
        _key: slide._key ?? String(index),
        type: slide.type ?? CarouselSectionTypes.Text,
        cta: transformLink(slide.cta),
      }))
  }, [textCarouselDeck])

  if (slides.length === 0) {
    return null
  }

  return (
    <section className="w-full">
      <CarouselFullWidth slides={slides} />
    </section>
  )
}

export default CarouselSectionText
